// extracted by mini-css-extract-plugin
export var menuIcon = "_po-0";
export var menuIconInline = "_po-1";